export const logoutType = 'logoutType';

export const Licenses = {
  Reaxys: 'Reaxys:Reaxys',
  ReaxysMedChem: 'Reaxys:ReaxysMedChem',
  Both: 'Reaxys:Both',
};

export const SessionExpiredMessage = 'Your session has expired';

export const SessionExpiredBody =
  "You have been inactive for a while. For your privacy and security, your session has expired. We'll bring you back to Reaxys homepage.";
